module.exports = __webpack_public_path__ + "img/icon_PayByShop-01.13e7b0e4.svg";